import Button from '@Components/Buttons/Button'
import React from 'react'
import Popup from '@Components/Popups/Popup'

interface ClaimNoPublishersPopupProps {
    closeModal: () => void
}

const ClaimNoPublishersPopup = ({ closeModal }: ClaimNoPublishersPopupProps) => (
    <Popup onClose={closeModal}>
        <h2>No eligible publisher found.</h2>
        <p>
            You are not authorized to alter any existing shares on this work. To continue with your claim, please add a
            publisher and/or administrator in order to assign shares.
        </p>
        <div className="button-row">
            <Button mainColor type="primary" onClick={closeModal}>
                Okay
            </Button>
        </div>
    </Popup>
)

export default ClaimNoPublishersPopup
